export default class AWSLambdaManager {
  constructor(LambdaClient) {
    this.lambda = LambdaClient;
  }

  /* const api_url =
        "https://ry3u6norc3.execute-api.eu-west-1.amazonaws.com/opticloudconfiguration/configure";

      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer ''", // Replace with your actual access token
      };

      const body = new URLSearchParams();
      body.append("api", api);*/
  async CallApi(api_url, method, headers, body) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(api_url, {
          method: method,
          headers: headers,
          body: JSON.stringify(body),
        });

        if (response.status === 200) {
          const data = await response.json();
          resolve(data);
        } else {
          const errorMsg = await response.text();
          reject(new Error(errorMsg));
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  async Invoke(FunctionName, InvocationType, Payload) {
    // Define the parameters for invoking the Lambda function
    const params = {
      FunctionName: FunctionName, // The name of the Lambda function
      InvocationType: InvocationType, // Invocation type can be 'RequestResponse', 'Event', or 'DryRun'
      Payload: JSON.stringify(Payload), // The payload as a JSON string
    };

    // Return a promise that resolves or rejects based on the Lambda invocation
    return new Promise(async (resolve, reject) => {
      await this.lambda.invoke(params, function (err, data) {
        if (err) {
          console.error("Error invoking Lambda function:", err);
          reject(err); // Reject the promise with the error
        } else {
          resolve(JSON.parse(data.Payload)); // Resolve the promise with the parsed payload
        }
      });
    });
  }
}
